// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__xvcPw","content":"footer_content__jxJwa","image":"footer_image__78ZBO","iconWrapper":"footer_iconWrapper__Y6v61"};